import { http, HttpResponse } from 'msw';
import { PlessService } from '../../../app/shared/pless-service.model';
import { ResponseUtils } from '../response-utils';

export const kymw6001Handlers = [
  // CWS使用画像一覧表出力情報取得 /kymw60/getCwsPlanGoodsUseImageGroupDispList
  http.post(PlessService.SERVICE.getCwsPlanGoodsUseImageGroupDispList.url, async ({ request }) => {
    const req = await request;
    console.log(PlessService.SERVICE.getCwsPlanGoodsUseImageGroupDispList.url, req);
    return HttpResponse.json(GetCwsPlanGoodsUseImageGroupDispListResponse);
    // return HttpResponse.json(GetBlankCwsPlanGoodsUseImageGroupDispListResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 使用画像の確認状況更新 /kymw60/updateCheckStatus
  http.post(PlessService.SERVICE.updateCheckStatus.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.updateCheckStatus.url, req);
    return ResponseUtils.getSuccess();
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),
];

const GetCwsPlanGoodsUseImageGroupDispListResponse = {
    "status": "ok",
    "message": "処理完了",
    "result": {
        "obj": {
            "TotalNum": 6,
            "StartDispNum": 1,
            "EndDispNum": 6,
            "PCodeInfoList": [
              {
                "PCode": "P1311662", // ながの、にいがたが取扱無
                "CoopInfoList": [
                  {
                    "CoopCode": "142",
                    "OrderNum": "000002"
                  },
                  {
                    "CoopCode": "163",
                    "OrderNum": "000001"
                  },
                  {
                    "CoopCode": "185",
                    "OrderNum": "000001"
                  },
                  {
                    "CoopCode": "240",
                    "OrderNum": "000001"
                  },
                  {
                    "CoopCode": "210",
                    "OrderNum": "000001"
                  },
                  {
                    "CoopCode": "302",
                    "OrderNum": "000001"
                  },
                ]
              },
              {
                "PCode": "P2599021",  // 全生協取扱あり
                "CoopInfoList": [
                  {
                    "CoopCode": "142",
                    "OrderNum": "000003"
                  },
                  {
                    "CoopCode": "163",
                    "OrderNum": "000002"
                  },
                  {
                    "CoopCode": "185",
                    "OrderNum": "000002"
                  },
                  {
                    "CoopCode": "240",
                    "OrderNum": "000002"
                  },
                  {
                    "CoopCode": "210",
                    "OrderNum": "000002"
                  },
                  {
                    "CoopCode": "302",
                    "OrderNum": "000002"
                  },
                  {
                    "CoopCode": "515",
                    "OrderNum": "000001"
                  },
                  {
                    "CoopCode": "451",
                    "OrderNum": "000001"
                  },
                ]
              },
              {
                "PCode": "P2632113",  // いばらきのみ取扱あり、注文コード設定なし
                "CoopInfoList": [
                  {
                    "CoopCode": "142",
                    "OrderNum": ""
                  },
                ]
              },
            ],
            "GoodsUseImageList": [
                {
                    "OrderCode": "2026100",
                    "ClassCode": "04",
                    "ClassNameKanji": "日配",
                    "PCode": "P1311662",
                    "GoodsName": "おいしいレモン（乳飲料）",
                    "GoodsStandardName": "２００ｍｌ",
                    "OrderNum142": "000002",
                    "OrderNum163": "000001",
                    "OrderNum185": "",
                    "OrderNum240": "",
                    "OrderNum210": "",
                    "OrderNum302": "",
                    "OrderNum515": "",
                    "OrderNum451": "",
                    "CoopFlg142": "1",
                    "CoopFlg163": "1",
                    "CoopFlg185": "0",
                    "CoopFlg240": "0",
                    "CoopFlg210": "0",
                    "CoopFlg302": "0",
                    "CoopFlg515": "0",
                    "CoopFlg451": "0",
                    "SkuFlg": "0",
                    "CrossFlg": "0",
                    "ImageList": []
                },
                {
                    "OrderCode": "2026100",
                    "ClassCode": "04",
                    "ClassNameKanji": "日配",
                    "PCode": "P1311662",
                    "GoodsName": "おいしいレモン（乳飲料）",
                    "GoodsStandardName": "２００ｍｌ",
                    "OrderNum142": "",
                    "OrderNum163": "",
                    "OrderNum185": "000001",
                    "OrderNum240": "000001",
                    "OrderNum210": "000001",
                    "OrderNum302": "000001",
                    "OrderNum515": "",
                    "OrderNum451": "",
                    "CoopFlg142": "0",
                    "CoopFlg163": "0",
                    "CoopFlg185": "1",
                    "CoopFlg240": "1",
                    "CoopFlg210": "1",
                    "CoopFlg302": "1",
                    "CoopFlg515": "0",
                    "CoopFlg451": "0",
                    "SkuFlg": "0",
                    "CrossFlg": "0",
                    "ImageList": [
                        {
                            "ImageId": "25069",
                            "ImageFileName": "P1311662A_01",
                            "FileImagePath": "http://localhost:4566/contents-bucket/N_PEACE/file/data/WebData/image/IMG_026/P1311662A_01M.jpg?20260318153519",
                            "ImageCheckFlag": "0",
                            "ShowSeq": "1",
                            "ImageName": "P1311662A",
                            "StartOrderCodeImageId": "2004010",
                            "TextCaption": "",
                            "CookingExPublish": "0"
                        },
                        {
                            "ImageId": "194630",
                            "ImageFileName": "P1311662C_01",
                            "FileImagePath": "http://localhost:4566/contents-bucket/N_PEACE/file/data/WebData/image/IMG_187/P1311662C_01M.jpg?20260318153519",
                            "ImageCheckFlag": "0",
                            "ShowSeq": "2",
                            "ImageName": "P1311662C",
                            "StartOrderCodeImageId": "2012360",
                            "TextCaption": "",
                            "CookingExPublish": "0"
                        }
                    ]
                },
                {
                    "OrderCode": "2026100",
                    "ClassCode": "02",
                    "ClassNameKanji": "水産",
                    "PCode": "P2599021",
                    "GoodsName": "海鮮丼",
                    "GoodsStandardName": "９０ｇ（４５ｇ×２）",
                    "OrderNum142": "000003",
                    "OrderNum163": "000002",
                    "OrderNum185": "000002",
                    "OrderNum240": "000002",
                    "OrderNum210": "000002",
                    "OrderNum302": "000002",
                    "OrderNum515": "000001",
                    "OrderNum451": "000001",
                    "CoopFlg142": "1",
                    "CoopFlg163": "1",
                    "CoopFlg185": "1",
                    "CoopFlg240": "1",
                    "CoopFlg210": "1",
                    "CoopFlg302": "1",
                    "CoopFlg515": "1",
                    "CoopFlg451": "1",
                    "SkuFlg": "0",
                    "CrossFlg": "0",
                    "ImageList": []
                },
                {
                    "OrderCode": "2026100",
                    "ClassCode": "01",
                    "ClassNameKanji": "農産",
                    "PCode": "P2632113",
                    "GoodsName": "グリーンピース（サヤ付）",
                    "GoodsStandardName": "２００ｇ",
                    "OrderNum142": "",
                    "OrderNum163": "",
                    "OrderNum185": "",
                    "OrderNum240": "",
                    "OrderNum210": "",
                    "OrderNum302": "",
                    "OrderNum515": "",
                    "OrderNum451": "",
                    "CoopFlg142": "1",
                    "CoopFlg163": "0",
                    "CoopFlg185": "0",
                    "CoopFlg240": "0",
                    "CoopFlg210": "0",
                    "CoopFlg302": "0",
                    "CoopFlg515": "0",
                    "CoopFlg451": "0",
                    "SkuFlg": "0",
                    "CrossFlg": "0",
                    "ImageList": [
                        {
                            "ImageId": "487984",
                            "ImageFileName": "P2632113A_01",
                            "FileImagePath": "http://localhost:4566/contents-bucket/N_PEACE/file/data/WebData/image/IMG_478/P2632113A_01M.jpg?20260318153519",
                            "ImageCheckFlag": "0",
                            "ShowSeq": "1",
                            "ImageName": "P2632113A",
                            "StartOrderCodeImageId": "2019490",
                            "TextCaption": "",
                            "CookingExPublish": "0"
                        },
                        {
                            "ImageId": "487985",
                            "ImageFileName": "P2632113B_01",
                            "FileImagePath": "http://localhost:4566/contents-bucket/N_PEACE/file/data/WebData/image/IMG_478/P2632113B_01M.jpg?20260318153519",
                            "ImageCheckFlag": "0",
                            "ShowSeq": "2",
                            "ImageName": "P2632113B",
                            "StartOrderCodeImageId": "2019490",
                            "TextCaption": "",
                            "CookingExPublish": "0"
                        },
                        {
                            "ImageId": "487986",
                            "ImageFileName": "P2632113C_01",
                            "FileImagePath": "http://localhost:4566/contents-bucket/N_PEACE/file/data/WebData/image/IMG_478/P2632113C_01M.jpg?20260318153519",
                            "ImageCheckFlag": "0",
                            "ShowSeq": "3",
                            "ImageName": "P2632113C",
                            "StartOrderCodeImageId": "2019490",
                            "TextCaption": "",
                            "CookingExPublish": "1"
                        },
                        {
                            "ImageId": "487987",
                            "ImageFileName": "P2632113C_02",
                            "FileImagePath": "http://localhost:4566/contents-bucket/N_PEACE/file/data/WebData/image/IMG_478/P2632113C_02M.jpg?20260318153519",
                            "ImageCheckFlag": "0",
                            "ShowSeq": "4",
                            "ImageName": "P2632113C",
                            "StartOrderCodeImageId": "2019490",
                            "TextCaption": "",
                            "CookingExPublish": "1"
                        }
                    ]
                },
            ]
        }
    }
}

const GetBlankCwsPlanGoodsUseImageGroupDispListResponse = {
  "status": "ok",
  "message": "処理終了",
  "result": {
    "obj": {
      "TotalNum": 3747,
      "StartDispNum": 101,
      "EndDispNum": 200,
      "GoodsUseImageList": []
    }
  }
}



